module.exports = __webpack_public_path__ + "static/img/logo11.b566c1a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo11.png
// module id = oiV5
// module chunks = 1